/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_HumidifierInputs */



/**
* | output |
* | --- |
* | "Humidifier" |
*
* @param {Ahu_History_Key_HumidifierInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const ahu_history_key_humidifier = /** @type {((inputs?: Ahu_History_Key_HumidifierInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_HumidifierInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Humidifier")
	return /** @type {LocalizedString} */ ("Humidificateur")
});